import Vue from "vue";
import {Table,notification,ConfigProvider,Button,Col,Form,Input,Select,Row,DatePicker,Spin,Result,Modal} from 'ant-design-vue';


notification.config({
    placement: 'topRight',
    top: '50px',
    duration: 3,
});


Vue.use(Table);
Vue.use(Result);
Vue.use(Modal);
Vue.use(DatePicker);
Vue.use(Row);
Vue.use(Select);
Vue.use(Input);
Vue.use(Form);
Vue.use(Button);
Vue.use(Spin);
Vue.use(Col);
Vue.use(ConfigProvider);

